import { getCountries, getCountryCallingCode } from 'libphonenumber-js';

const getUniqueCountryCallingCode = () => {
    const countryCallingCodes = new Set();
    getCountries().forEach(country => {
        const countryCode = getCountryCallingCode(country);
        countryCallingCodes.add(!Number.isNaN(countryCode) && Number(countryCode));
    });
    const sortedCountryCallingCodes = [...countryCallingCodes].sort((a, b) => a - b);
    return sortedCountryCallingCodes;
};

export default getUniqueCountryCallingCode;
